import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

/**
 * What a list shows when it has nothing to show.
 *
 * Three situations look identical to a component and completely different to
 * the person reading them: nothing exists yet, a search matched nothing, or
 * filters excluded everything. Collapsing them into one blank area (or, worse,
 * empty rows) leaves the operator unable to tell whether they have a data
 * problem or a filter problem — so the caller states which case it is and, for
 * the recoverable ones, offers the way out.
 */
const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '64px var(--careco-space-lg)',
    background: 'var(--careco-surface)',
    fontFamily: 'var(--careco-font)',
  },
  compact: {
    padding: '40px var(--careco-space-lg)',
  },
  title: {
    margin: 0,
    fontSize: 14,
    fontWeight: 600,
    color: 'var(--careco-text-primary)',
  },
  body: {
    margin: '6px 0 0',
    fontSize: 14,
    color: 'var(--careco-text-muted)',
    maxWidth: '52ch',
  },
  action: {
    marginTop: 'var(--careco-space-md)',
  },
})

const EmptyState = ({ classes, title, description, action, compact, transparent }) => (
  <div
    className={`${classes.root} ${compact ? classes.compact : ''}`}
    style={transparent ? { background: 'transparent' } : undefined}>
    <p className={classes.title}>{title}</p>
    {description && <p className={classes.body}>{description}</p>}
    {action && <div className={classes.action}>{action}</div>}
  </div>
)

EmptyState.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  action: PropTypes.node,
  compact: PropTypes.bool,
  transparent: PropTypes.bool,
}

export default withStyles(styles)(EmptyState)
